export default __webpack_public_path__ + "static/media/create-campaigns-1.28fac9a0.png";